export type UserRole = "user" | "support" | "admin";

export const STAFF_ROLES: readonly UserRole[] = ["support", "admin"] as const;

export function isStaffRole(role: UserRole | string | null | undefined): boolean {
	return role === "support" || role === "admin";
}

export function isAdminRole(role: UserRole | string | null | undefined): boolean {
	return role === "admin";
}

export function isAssignableStaffRole(role: string): role is "support" | "admin" {
	return role === "support" || role === "admin";
}
